export default __webpack_public_path__ + "static/mini-6-95aa677dff054919fed4aa3bd46781b6.png";